import { render, staticRenderFns } from "./TabVideo.vue?vue&type=template&id=06f949f2&scoped=true&"
import script from "./TabVideo.vue?vue&type=script&lang=js&"
export * from "./TabVideo.vue?vue&type=script&lang=js&"
import style0 from "./TabVideo.vue?vue&type=style&index=0&id=06f949f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f949f2",
  null
  
)

export default component.exports